import { useState, useEffect, useCallback, useMemo } from "react";
import { adminApi } from "../../api";

/**
 * Orders list filtered by state (URL param). Owns search/page/pageSize.
 * Resets page+search whenever the URL state changes.
 */
export default function useOrdersByState(state) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [availableStates, setAvailableStates] = useState([]);

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const r = await adminApi.ordersByState(state, { page, page_size: pageSize, search });
      setRows(r.data || []);
      setTotal(r.total || 0);
    } catch (e) {
      setError(e.message || "Erro");
      setRows([]);
    } finally { setLoading(false); }
  }, [state, page, pageSize, search]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    adminApi.orderStates().then((r) => setAvailableStates(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => { setPage(1); setSearch(""); }, [state]);

  const totalPages = useMemo(() => Math.max(1, Math.ceil(total / pageSize)), [total, pageSize]);
  const currentStateLabel = rows[0]?.state_label || state;

  return {
    rows, total, page, setPage, pageSize, setPageSize,
    search, setSearch, loading, error,
    availableStates, totalPages, currentStateLabel,
    load,
  };
}
